import { propertyManagingAgentCard } from '../../shared';
import type { ListingLocaleOverrides } from '../base';
import { buyersAttorneyContactCard } from '../cards';

export const NJOverrides: ListingLocaleOverrides = {
  locale: 'NJ',
  sections: {
    propertyInfo: {
      cards: {
        propertyBeingSoldCard: {
          layout: (layout) =>
            layout.concat([
              [
                {
                  name: 'property.lot',
                  size: 50,
                },
                {
                  name: 'property.block',
                  size: 50,
                },
              ],
            ]),
          fields: {
            lot: {
              name: 'property.lot',
              entity: 'property',
              type: 'text',
              label: 'Lot',
              placeholderText: '',
            },
            block: {
              name: 'property.block',
              entity: 'property',
              type: 'text',
              label: 'Block',
              placeholderText: '',
            },
          },
        },
      },
    },
    buyerSideContacts: {
      cards: {
        buyersAttorneyContactCard,
      },
    },
    additionalContacts: {
      cards: {
        titleOfficerContactCard: {
          order: 2,
        },
        attorneyContactCard: () => propertyManagingAgentCard,
        addAdditionalContactCard: {
          fields: {
            newContact: {
              options: () => [
                {
                  label: 'Property Managing Agent',
                  value: 'additionalContacts.propertyManagingAgent',
                },
                {
                  label: 'Appraiser',
                  value: 'additionalContacts.appraiser',
                },
                {
                  label: 'Home Warranty',
                  value: 'additionalContacts.homeWarranty',
                },
                {
                  label: 'Other',
                  value: 'additionalContacts.other',
                },
              ],
            },
          },
        },
      },
    },
  },
};
